import initVueApp from "@/core.js";
const component = require(`./../views/Search.vue`).default;
initVueApp(component);
